import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';


class PopUpPermisosNoAsignados extends Component {
    constructor(props) {
        super(props);
        this.state = {
            perfilesSeleccionados: [],
            permisos: [],
            productos: [],
            categorias: [],
            programas: []
        }
    }

    componentDidMount() {
        this.setState({
            perfilesSeleccionados: this.props.perfilesSeleccionados,
            permisos: this.props.permisos,
            productos: this.props.productos,
            categorias: this.props.categorias,
            programas: this.props.programas
        });
    }
    componentWillReceiveProps() {
        this.setState({
            perfilesSeleccionados: this.props.perfilesSeleccionados,
            permisos: this.props.permisos,
            productos: this.props.productos,
            categorias: this.props.categorias,
            programas: this.props.programas
        });
    }

    save = () => {
        this.props.save();
    }
    render() {

        const { perfilesSeleccionados, permisos, productos, categorias, programas } = this.state;
        const save = this.state;

        var listaAMostar = [];
        var localValuesAMostrar = {};

        perfilesSeleccionados.forEach(function (perfil) {

            // si ProductoId es null tiene asociado todos los productos
            if (perfil.ProductoId != null) {

                var perfilDescripcion = perfil.Codigo;
                var cateroriaPrograma = "";

                permisos.forEach(function (permiso) {

                    if (perfil.ProductoId != permiso.productoId && permiso.programaId != 0) {

                        var producto = productos.find(prod => prod.Id == permiso.productoId).Descripcion;
                        var categoria = categorias.find(catego => catego.Id == permiso.categoriaId).Descripcion;
                        var programa = programas.find(programa => programa.Id == permiso.programaId).Descripcion;
                        cateroriaPrograma = cateroriaPrograma + producto + ' - ' + categoria + " - " + programa + "\n";
                    }
                });

                if (perfilDescripcion && cateroriaPrograma) {

                    localValuesAMostrar = {
                        'perfil': perfilDescripcion,
                        'cateroriaPrograma': cateroriaPrograma,
                    };

                    listaAMostar.push(localValuesAMostrar);

                    perfilDescripcion = cateroriaPrograma = "";
                }

            }
        });


        const permisosNoAsigandosAMostrar = listaAMostar.map((primerElemento) => {
            return <div>
                <h3>{primerElemento.perfil}</h3>
                <p>{primerElemento.cateroriaPrograma}</p>
            </div>
        });
        return (
            <div className="modal fade-out" id="permisosSobrePerfil" role="dialog" data-backdrop="static" >
                <div className="modal-dialog modal-md">
                    <div className="modal-content" style={{ width: "470px" }}>
                        <div className="modal-header" data-label="Título" style={{ height: "120px" }}>
                            <div className="close" data-dismiss="modal" aria-hidden="true">
                                <label className="ti-close clickable"></label>
                            </div>
                            <h3 className="modal-title">Algunos permisos no se aplicarán. Los siguientes perfiles están asociados a un sistema y los permisos a otro:</h3>
                        </div>

                        <div className="modal-body">
                            <div className="vertical-scrollable-container-md">
                                {permisosNoAsigandosAMostrar}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <div className="row">
                                <div className="col-xs-5">
                                    <GenericSimpleButton text="Continuar"
                                        buttonClass="btn btn-primary btn-cta"
                                        dataDismiss="modal"
                                        onClick={this.save} />
                                </div>
                                <div className="col-xs-7">
                                    <GenericSimpleButton text="Cancelar"
                                        buttonClass="btn btn-default btn-secondary"
                                        dataDismiss="modal" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default PopUpPermisosNoAsignados;